/* eslint-disable import/no-anonymous-default-export */

import React, { useState } from "react";
// import { BrowserRouter as Router } from "react-router-dom";
//import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Link, Switch } from "react-router-dom";
import Main from "./components/Landing";
import ThankYou from "./components/thankYou/thankYou";
import Navbar from "./components/navigation/navbar";
import MultiStepsBooking from "./components/multiStepsForm/MultiStepsBooking";
import NoFound from "./components/messages/noFound"

export default (_) => {
  const [page, setPage] = useState(0);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "auto 1fr auto",
        height: "100%",
      }}
    >
      <Navbar setPage={setPage} page={page}/>
      <Switch>
        
        <Route exact path="/">
          <div
            className="Pages-Wrapper"
            style={{
              display: "grid",
              gridTemplateColumns: "auto min(150ch - 1rem , 90vw) auto",
              rowGap: "1rem",
              overFlowX: "hidden",
            }}
          >
            {page === 0 ? <Main setPage={setPage} /> : null}
            {/* {page === 1 ? <MultiStepsBooking setPage={setPage} /> : null} */}
          </div>
        </Route>
        <Route exact path="/booking">
          <div
            className="Pages-Wrapper"
            style={{
              display: "grid",
              gridTemplateColumns: "auto min(150ch - 1rem , 90vw) auto",
              rowGap: "1rem",
              overFlowX: "hidden",
            }}
          >
            {page === 1 ? <MultiStepsBooking setPage={setPage} /> : <NoFound setPage={setPage} page={page}/>}
          </div>
        </Route>
        <Route exact path="/confirm">
          {page === 1 ? <ThankYou setPage={setPage}/>  : <NoFound setPage={setPage} page={page}/>}
        {/* <ThankYou setPage={setPage}/>  */}
        </Route>
        <Route path='*' ><NoFound setPage={setPage} page={page}/></Route>
      </Switch>
      <footer
        style={{ textAlign: "right", marginRight: "1rem", padding: "1rem" }}
      >
        Made with Love! ❤️ John.Y{" "}
      </footer>
    </div>
  );
};
